import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the message interface
interface Message {
  id: string;
  icon: string;
  title: string;
  text: string;
  duration: number;
}

// Define our initial state
const initialState: Message[] = [];

export const messageQueueSlice = createSlice({
  name: 'messageQueue',
  initialState,
  reducers: {
    // Add a message to the queue
    addMessage: (state, action: PayloadAction<Message>) => {
      const { id, icon, title, text, duration } = action.payload;
      state.push({ id, icon, title, text, duration });
    },
    // Remove a message by ID
    removeMessage: (state, action: PayloadAction<string>) => {
      const idToRemove = action.payload;
      return state.filter((message) => message.id !== idToRemove);
    }
  }
});

export const { addMessage, removeMessage } = messageQueueSlice.actions;
export default messageQueueSlice.reducer;
